import JPaginationBox from './JPaginationBox'
export { JPaginationBox }
export default JPaginationBox